import { BaseModal, theme } from "@pallet-hq/hegel"
import OnboardingLayout from "components/OnboardingLayout"
import { useEffect, useState } from "react"
import useHelpMenu from "state/useHelpMenu"
import Login from "./Login"
import Signup from "./Signup"

type OnboardingModalProps = {
    isOpen: boolean
    hideModal: () => void
    onSuccess: () => any
    heading?: string
    subheading?: string
}

const OnboardingModal = (props: OnboardingModalProps) => {
    const [isLoggingIn, setLoggingIn] = useState(false)
    const { setIsVisible } = useHelpMenu()
    const LoginComponent = isLoggingIn ? Login : Signup

    useEffect(() => {
        setIsVisible(!props.isOpen)
    }, [props.isOpen, setIsVisible])

    return (
        <BaseModal
            style={{
                overlay: {
                    backgroundColor: theme.colors.black4,
                    zIndex: 2,
                },
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    width: "calc(100% - 48px)",
                    height: "calc(100% - 48px)",
                    maxWidth: "1392px",
                    maxHeight: "860px",
                    borderRadius: "16px",
                    boxShadow:
                        "0px 1px 6px rgba(0, 0, 0, 0.16), 0px 6px 20px rgba(0, 0, 0, 0.2)",
                },
            }}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            {...props}
        >
            <OnboardingLayout
                heading={props.heading || "With your Pallet account, "}
                subheading={
                    props.subheading ||
                    "you can share your profile, apply for jobs, join new collectives, and so much more."
                }
            >
                <LoginComponent setLoggingIn={setLoggingIn} {...props} />
            </OnboardingLayout>
        </BaseModal>
    )
}

export default OnboardingModal
